import {of} from 'rxjs';
import {catchError, map, mergeMap, retryWhen, delay} from 'rxjs/operators';
import {ajax} from 'rxjs/ajax';
import { getApiHeader, getSecurityApiHeader  } from './ApiUtil';
import * as ErrorConstants from '../constants/ErrorConstants';
import * as SecuritySSOConstants from '../constants/SecuritySSOConstants';
import * as LoginActions from '../actions/LoginActions';
import {COUNTRIES} from '../constants/AppConstants';
import {TokenResponseParameter, HeaderParameter} from '../../common/types/common';
import {AUTHORIZATION_SERVERLESS} from '../../common/constants/AppConstants';

const maxTimesRetry = 1;
const maxTimesRetryAjax0 = 2;

// function refreshToken(state) {
//     const url = `${SecuritySSOConstants.SECURITY_URL}/authorization/refresh-token`;
//     return ajax.get(url, getSecurityApiHeader(state)).pipe(map((response: any) => {
//         return response.response.data;
//     }));
// }

function refreshToken(state) {
    const url = SecuritySSOConstants.getSSOTokenUrl(state.countrySelector.countrySelected);
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    const body = {client_id: SecuritySSOConstants.SSO_CLIENT_ID, grant_type: 'refresh_token', refresh_token: state.profile.refreshToken};
    return ajax.post(url, new URLSearchParams(body).toString(), headers).pipe(map((response: any) => {
        return response.response;
    }));
}

function hasError(errorResponse, errorToFind) {
    return getErrors(errorResponse).includes(errorToFind);
}

function getLinkedMessages(notifications) {
    return notifications.linkedMessages ? notifications.linkedMessages : [];
}

function getErrors(errorResponse) {
    console.log('.........-getErrorsgetErrorsgetErrorsgetErrors-------------------', errorResponse, errorResponse.xhr);
    return errorResponse.xhr.response && errorResponse.xhr.response.notifications &&
        [...errorResponse.xhr.response.notifications.errorMessages,
            ...getLinkedMessages(errorResponse.xhr.response.notifications)]
            || [errorResponse];
}

export const addHeadersServerless = (apiCall, contentType = 'application/json') => {
    const getHeaders = () => ({
        'Content-Type': contentType,
        Authorization: AUTHORIZATION_SERVERLESS
    });

    return of('').pipe(
        mergeMap(() => {
            const newHeaders = getHeaders();
            return apiCall(newHeaders).pipe(map(response => ({response})));
        })
    );
};

export const addCredentialAndExecute = (apiCall,
                                        state,
                                        isSecurityApi = false,
                                        contentType = 'application/json',
                                        lambdaAuthorization = '') => {
    let timesRetried = 0;
    let timesRetriedAjax0 = 0;
    let header: HeaderParameter = isSecurityApi ?
        getSecurityApiHeader(state) : getApiHeader(state, !!!lambdaAuthorization);
    let refreshTokenObs =
        LoginActions.CHANGE_TOKENS_ACTION.action(state.profile.accessToken, state.profile.refreshToken);
    const getHeaders = () => ({
        ...header,
        'Content-Type': contentType,
        Authorization: lambdaAuthorization ? lambdaAuthorization : header['Authorization'],
    });

    return of('').pipe(
        mergeMap(() => {
            const newHeaders = getHeaders();
            if (newHeaders['Content-Type'] === 'multipart/form-data') {
                delete newHeaders['Content-Type'];
            }
            return apiCall(newHeaders).pipe(map(response => ({response, refreshTokenObs})));
        }),
    retryWhen((observerError) => {

        return observerError.pipe(
            mergeMap((error) => {
                timesRetried = timesRetried + 1;
                if (hasError(error, ErrorConstants.ACCESS_TOKEN_EXPIRED_ERROR) && timesRetried <= maxTimesRetry) {
                    return refreshToken(state).pipe(
                        map((response: {
                            access_token: string;
                            refresh_token: string;
                        }) => {
                            refreshTokenObs =
                                LoginActions.CHANGE_TOKENS_ACTION.action(response.access_token, response.refresh_token);
                            header = isSecurityApi ? {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                'refresh-token' : response.refresh_token,
                                'access-token' : response.access_token,
                                domain: SecuritySSOConstants.getKCClient(state.countrySelector.countrySelected)
                            } :{
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                Authorization : `Bearer ${response.access_token}`,
                                clientId : COUNTRIES[state.countrySelector.countrySelected].securityClientId
                            };
                        }), catchError((error) => {
                            throw getErrors(error);
                        }));
                }

                if (error.xhr && error.xhr.status === 0 && timesRetriedAjax0 <= maxTimesRetryAjax0) {
                    console.log('======================RETRY============================');
                    timesRetriedAjax0 = timesRetriedAjax0 + 1;
                    return of('').pipe(delay(2000), mergeMap(() => 'RETRY'));
                }
                throw getErrors(error);
            })
        );
    }));
};
